/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiLibraryScenarioCategory } from './InternalApiLibraryScenarioCategory';
import {
    InternalApiLibraryScenarioCategoryFromJSON,
    InternalApiLibraryScenarioCategoryFromJSONTyped,
    InternalApiLibraryScenarioCategoryToJSON,
    InternalApiLibraryScenarioCategoryToJSONTyped,
} from './InternalApiLibraryScenarioCategory';
import type { InternalApiScenarioStatus } from './InternalApiScenarioStatus';
import {
    InternalApiScenarioStatusFromJSON,
    InternalApiScenarioStatusFromJSONTyped,
    InternalApiScenarioStatusToJSON,
    InternalApiScenarioStatusToJSONTyped,
} from './InternalApiScenarioStatus';
import type { InternalApiScenarioTypeV2 } from './InternalApiScenarioTypeV2';
import {
    InternalApiScenarioTypeV2FromJSON,
    InternalApiScenarioTypeV2FromJSONTyped,
    InternalApiScenarioTypeV2ToJSON,
    InternalApiScenarioTypeV2ToJSONTyped,
} from './InternalApiScenarioTypeV2';
import type { InternalApiScenarioVersionParameter } from './InternalApiScenarioVersionParameter';
import {
    InternalApiScenarioVersionParameterFromJSON,
    InternalApiScenarioVersionParameterFromJSONTyped,
    InternalApiScenarioVersionParameterToJSON,
    InternalApiScenarioVersionParameterToJSONTyped,
} from './InternalApiScenarioVersionParameter';
import type { InternalApiScenarioEntityType } from './InternalApiScenarioEntityType';
import {
    InternalApiScenarioEntityTypeFromJSON,
    InternalApiScenarioEntityTypeFromJSONTyped,
    InternalApiScenarioEntityTypeToJSON,
    InternalApiScenarioEntityTypeToJSONTyped,
} from './InternalApiScenarioEntityType';

/**
 * 
 * @export
 * @interface InternalApiLibraryScenario
 */
export interface InternalApiLibraryScenario {
    /**
     * 
     * @type {string}
     * @memberof InternalApiLibraryScenario
     */
    id: string;
    /**
     * 
     * @type {InternalApiScenarioEntityType}
     * @memberof InternalApiLibraryScenario
     */
    entityType: InternalApiScenarioEntityType;
    /**
     * 
     * @type {Array<InternalApiScenarioTypeV2>}
     * @memberof InternalApiLibraryScenario
     */
    type: Array<InternalApiScenarioTypeV2>;
    /**
     * 
     * @type {string}
     * @memberof InternalApiLibraryScenario
     */
    name: string;
    /**
     * 
     * @type {InternalApiScenarioStatus}
     * @memberof InternalApiLibraryScenario
     */
    status: InternalApiScenarioStatus;
    /**
     * 
     * @type {Array<InternalApiLibraryScenarioCategory>}
     * @memberof InternalApiLibraryScenario
     */
    categories: Array<InternalApiLibraryScenarioCategory>;
    /**
     * 
     * @type {string}
     * @memberof InternalApiLibraryScenario
     */
    internalId?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiLibraryScenario
     */
    logic: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiLibraryScenario
     */
    details: string;
    /**
     * 
     * @type {Array<InternalApiScenarioVersionParameter>}
     * @memberof InternalApiLibraryScenario
     */
    parameters?: Array<InternalApiScenarioVersionParameter>;
    /**
     * 
     * @type {string}
     * @memberof InternalApiLibraryScenario
     */
    query: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiLibraryScenario
     */
    schemaRestrictions?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiLibraryScenario
     */
    segments: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiLibraryScenario
     */
    excludedSegments: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiLibraryScenario
     */
    includeRelatedTransactions: boolean;
}



/**
 * Check if a given object implements the InternalApiLibraryScenario interface.
 */
export function instanceOfInternalApiLibraryScenario(value: object): value is InternalApiLibraryScenario {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('categories' in value) || value['categories'] === undefined) return false;
    if (!('logic' in value) || value['logic'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('query' in value) || value['query'] === undefined) return false;
    if (!('segments' in value) || value['segments'] === undefined) return false;
    if (!('excludedSegments' in value) || value['excludedSegments'] === undefined) return false;
    if (!('includeRelatedTransactions' in value) || value['includeRelatedTransactions'] === undefined) return false;
    return true;
}

export function InternalApiLibraryScenarioFromJSON(json: any): InternalApiLibraryScenario {
    return InternalApiLibraryScenarioFromJSONTyped(json, false);
}

export function InternalApiLibraryScenarioFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiLibraryScenario {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'entityType': InternalApiScenarioEntityTypeFromJSON(json['entityType']),
        'type': ((json['type'] as Array<any>).map(InternalApiScenarioTypeV2FromJSON)),
        'name': json['name'],
        'status': InternalApiScenarioStatusFromJSON(json['status']),
        'categories': ((json['categories'] as Array<any>).map(InternalApiLibraryScenarioCategoryFromJSON)),
        'internalId': json['internalId'] == null ? undefined : json['internalId'],
        'logic': json['logic'],
        'details': json['details'],
        'parameters': json['parameters'] == null ? undefined : ((json['parameters'] as Array<any>).map(InternalApiScenarioVersionParameterFromJSON)),
        'query': json['query'],
        'schemaRestrictions': json['schemaRestrictions'] == null ? undefined : json['schemaRestrictions'],
        'segments': json['segments'],
        'excludedSegments': json['excludedSegments'],
        'includeRelatedTransactions': json['includeRelatedTransactions'],
    };
}

export function InternalApiLibraryScenarioToJSON(json: any): InternalApiLibraryScenario {
    return InternalApiLibraryScenarioToJSONTyped(json, false);
}

export function InternalApiLibraryScenarioToJSONTyped(value?: InternalApiLibraryScenario | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'entityType': InternalApiScenarioEntityTypeToJSON(value['entityType']),
        'type': ((value['type'] as Array<any>).map(InternalApiScenarioTypeV2ToJSON)),
        'name': value['name'],
        'status': InternalApiScenarioStatusToJSON(value['status']),
        'categories': ((value['categories'] as Array<any>).map(InternalApiLibraryScenarioCategoryToJSON)),
        'internalId': value['internalId'],
        'logic': value['logic'],
        'details': value['details'],
        'parameters': value['parameters'] == null ? undefined : ((value['parameters'] as Array<any>).map(InternalApiScenarioVersionParameterToJSON)),
        'query': value['query'],
        'schemaRestrictions': value['schemaRestrictions'],
        'segments': value['segments'],
        'excludedSegments': value['excludedSegments'],
        'includeRelatedTransactions': value['includeRelatedTransactions'],
    };
}

